import { motion } from "framer-motion";

const steps = [
  { n: "01", t: "Discovery", d: "We start by understanding your vision, audience, and aesthetic language." },
  { n: "02", t: "Moodboard & Direction", d: "Detailed moodboards and storyboards define tone, style, and narrative." },
  { n: "03", t: "Pre-Production", d: "Casting, styling, location scouting, set design, and creative direction." },
  { n: "04", t: "Production", d: "Cinematic filming and photography executed on-location or in studio." },
  { n: "05", t: "Post-Production", d: "Editorial color, sound, and finish — delivered cinema-grade." },
];

export default function Process() {
  return (
    <section id="process" className="relative py-28 md:py-40" data-testid="process-timeline">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <div className="flex items-center gap-3 mb-6">
                <span className="text-[11px] uppercase tracking-[0.4em] text-gold">Process</span>
                <span className="h-px w-16 bg-[#264738]" />
              </div>
              <h2 className="font-display text-ivory text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                End-to-end <br/><span className="italic text-gold">solutions.</span>
              </h2>
              <p className="mt-8 text-ivory-muted text-base font-light leading-relaxed">
                At StyleePix we collaborate with brands right from the beginning — understanding
                your vision, audience and aesthetic language. We craft moodboards and storyboards
                that define tone, style and narrative. Every frame aligned with the brand&apos;s
                identity, delivering a cinematic, high-impact visual experience.
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="relative">
              <div className="absolute left-[28px] top-2 bottom-2 w-px bg-[#264738]" />
              <div className="space-y-12">
                {steps.map((s, i) => (
                  <motion.div
                    key={s.n}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.7, delay: i * 0.08 }}
                    className="relative pl-20"
                    data-testid={`process-step-${i}`}
                  >
                    <div className="absolute left-0 top-0 w-14 h-14 bg-[#0F211A] border border-gold flex items-center justify-center font-display text-gold text-lg">
                      {s.n}
                    </div>
                    <h3 className="font-display text-ivory text-2xl md:text-3xl mb-3">{s.t}</h3>
                    <p className="text-ivory-muted text-base font-light leading-relaxed max-w-xl">{s.d}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
